import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import cellEditFactory from 'react-bootstrap-table2-editor';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, {
	PaginationProvider,
	PaginationListStandalone,
	PaginationTotalStandalone,
	SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'App.css';
import Spinner from 'Common/Spinner';
import {
	onStartEdit,
	unhideRows,
	showRows,
	areRowsHidden,
	AmendmentInfo,
	UnhideButton,
	getEditState,
	setUnhideStatus,
	getUpdateRowEdit
} from './Helpers/RowEditHelpers';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';

class ContractTemplateDatatable extends Component {
	constructor(props) {
		super(props);		

		this.state = {
			columns: props.columns(),
			keyField: props.keyField,
			pageNo: 1,
			pageSize: 10,
			isLoaded: false,
			searchText: '',
			searchYear: props.qualYear,
			updateYear: PropTypes.func.isRequired,
			timeout: null,
			selectedOption: 'active',
			templateActiveStatus: true,
			inPreview: false,
			templateQuery: props.query,
			key: Math.random(),
			...getEditState({ searchRef: 'searchComponentRef' })
		};
		this.componentRef = React.createRef();
		this.searchComponentRef = React.createRef();
		this.handleRdActiveStatusChange = this.handleRdActiveStatusChange.bind(this);
		this.updateYear = this.updateYear.bind(this);
		this.onStartEdit = (row, column, rowIndex, columnIndex, tableData) => {
			const { setEditMode } = props;
			const isEditing = onStartEdit.bind(this)(row, column, rowIndex, columnIndex, tableData);
			if (isEditing) {
				setEditMode(true);
			}
		};
		this.unhideRows = () => {
			const { setEditMode } = props;
			setEditMode(false);
			this.setState({ ...this.state });
			setTimeout(() => {
				unhideRows.apply(this);
			}, 500);
		};
		this.areRowsHidden = areRowsHidden.bind(this);
		this.getUpdateRowEdit = getUpdateRowEdit.bind(this);
		this.showRows = showRows.bind(this);
		this.setUnhideStatus = setUnhideStatus.bind(this);
		this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
	}

   
	handleRdActiveStatusChange(changeEvent) {
		this.setState({
			selectedOption: changeEvent.target.value
		});
		this.onChangeActiveStatus(changeEvent.target.value);
	}

	componentDidMount = () => {
		
		const { pageSize, templateActiveStatus, searchYear } = this.state;

		this.loadData(pageSize, templateActiveStatus, searchYear);
	};

	loadData = async (sizePerPage, activeStatus, searchYear) => {
		const { appointeeType, handleGetData, handleClearUpdates } = this.props;
		handleClearUpdates();
		let query = {
			sortOrder: 'asc',
			sortField: 'name',
			page: 1,
			sizePerPage,
			searchText: '',
			exportData: false
		};
		await handleGetData(appointeeType, activeStatus, searchYear, query);
		this.setState({ isLoaded: this.props.isLoaded });
	};

	static getDerivedStateFromProps(props) {
		const { isLoaded } = props;

		return {
			isLoaded
		};
	}

	componentDidUpdate() {
		const { fireShow, setFireShow, amendments } = this.props;
		if (fireShow) {
			this.showRows();
			setFireShow(false);
		}

		if (amendments === 0) {
			this.removePreview();
		}

		this.setUnhideStatus();
	}

	componentWillUnmount = () => this.props.handleClearUpdates();

	getQuery = (templateQuery, searchText, searchYear) => ({ ...templateQuery, searchText, searchYear });

	handleTableChange = async (type, state) => {
		let { sortOrder, sortField, page, sizePerPage } = state;
		let { templateActiveStatus, searchText, searchYear } = this.state;
		const { appointeeType, handleGetData } = this.props;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'name';
		page = type === 'search' ? 1 : page;

		this.setState({ isLoaded: false });
		const templateQuery = {
			sortOrder,
			sortField,
			page,
			sizePerPage,
			exportData: false
		};
		const query = this.getQuery(templateQuery, searchText);
		await handleGetData(appointeeType, templateActiveStatus, searchYear, query);

		const updateRowEdit = this.getUpdateRowEdit(searchText);
		this.setState({
			...this.state,
			pageNo: page,
			pageSize: sizePerPage,
			searchText,
			templateQuery,
			...updateRowEdit
		});
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	handleGetExportData = async props => {
		const { templateActiveStatus, searchYear} = this.state;
		const { appointeeType, handleGetData } = this.props;

		const query = {
			sortOrder: 'asc',
			sortField: 'name',
			page: 0,
			sizePerPage: 0,
			searchText: '',
			exportData: true
		};
		await handleGetData(appointeeType, templateActiveStatus, searchYear, query);
		props.onExport(this.props.all_data);
	};

	onChangeActiveStatus = async rdActiveValue => {
		let changedActiveStatus = false;
		if (rdActiveValue === 'active') changedActiveStatus = true;

		this.setState({ isLoaded: false });
		const { pageSize, searchText, searchYear } = this.state;
		const { appointeeType, handleGetData } = this.props;
		const templateQuery = {
			sortOrder: 'asc',
			sortField: 'name',
			page: 1,
			sizePerPage: pageSize,
			exportData: false
		};
		const query = this.getQuery(templateQuery, searchText);
		await handleGetData(appointeeType, changedActiveStatus, searchYear, query);

		this.setState({
			pageNo: 1,
			templateActiveStatus: changedActiveStatus,
			templateQuery
		});
	};

	focusSearchInput = input => {
		if (input && input.value.length > 0) {
			input.focus();
		} else {
			return false;
		}
	};

	onChangeSearchInput(event, searchProps) {
		this.setState({ searchText: event.target.value });
		this.handleCustomeSearch(event.target.value, searchProps);
	}

	handleCustomeSearch = (value, searchProps) => {
		const timeout = this.state;
		clearTimeout(timeout);
		this.setState({
			timeout: setTimeout(() => {
				searchProps.onSearch(value);
			}, 100)
		});
	};

	clearSearch = () => {
		const { pageSize, templateActiveStatus, searchYear} = this.state;
		this.setState({ searchText: '', pageNo: 1 });
		this.loadData(pageSize, templateActiveStatus, searchYear);
	};

	displayWarning = message => {
		const { dispatch } = this.props;
		dispatch({ type: ADD_TOAST_MESSAGE, payload: { severity: 'warning', message } });
	};

	checkEditability = (oldValue, newValue, row, column, done) => {
		const { inPreview } = this.state;
		let editable = true;

		if (inPreview) {
			editable = false;
			this.displayWarning('To edit please exit preview');
		}

		setTimeout(() => (editable ? done() : done(false)), 100);
		return { async: true };
	};

	checkUpdate = (field, val, rowData) => {
		const { dataCopy, updated } = this.props;
		const isInOriginalData = dataCopy.find(rowCopy => isEqual(rowCopy, rowData));

		if (!isInOriginalData) {
			const _rowData = cloneDeep(rowData);
			const { handleAddUpdates } = this.props;
			handleAddUpdates(field, val, _rowData, updated);
		} else {
			const { removeUpdate, keyField } = this.props;
			removeUpdate(keyField, rowData[keyField], updated);
		}
	};

	removeAllEdits = () => {
		const { handleRemoveAllEdits } = this.props;
		handleRemoveAllEdits();
	};

	previewClick = () => {
		const { inPreview } = this.state;
		this.setState({ inPreview: !inPreview });
	}

	removePreview = () => {
		const { inPreview } = this.state;
		if (inPreview) {
			this.setState({ inPreview: false });
		}
	};

	updateYear = async year => {
		this.setState({ isLoaded: false });
		const { appointeeType, handleGetData } = this.props;
		const { selectedOption } = this.state;
		const selectedYear = year;
		this.state.searchYear = year;
		const sizePerPage = this.state.pageSize;
		let activeStatus = false;
		if (selectedOption === 'active') {
			activeStatus = true;
		}
		let query = {
			sortOrder: 'asc',
			sortField: 'name',
			page: 1,
			sizePerPage,
			searchText: '',
			exportData: false
		};
		this.setState({ isLoaded: false });
		await handleGetData(appointeeType, activeStatus, selectedYear, query);
 
	};
	

	render() {
		const {
			keyField,
			columns,
			pageNo,
			pageSize,
			isLoaded,
			inPreview,
			hiddenRows,
			searchText,
			searchYear
		} = this.state;

		const {
			total,
			updated,
			data,
			amendments,
			appointeeType 
		} = this.props;

		const CustomCsvButton = props => (
			<button
				className="react-bs-table-csv-btn btn btn-default btn-primary"
				style={{ height: '45px', width: '200px' }}
				onClick={() => this.handleGetExportData(props)}
			>
				Export CSV
			</button>
		);

		const hasAmendments = amendments > 0;
		const viewData = inPreview ? updated : data;
		const showPagination = !this.areRowsHidden() && !inPreview;
		const handleUpdateYear = this.updateYear;
		const CustomSearch = React.forwardRef((searchProps, ref) => {
			return (
				<div>
					<label htmlFor="search-bar-1" class="search-label">
						<span id="search-bar-1-label" class="sr-only">
							Search this table
						</span>
						<input
							className="searchInput form-control"
							ref={this.focusSearchInput}
							value={searchText}
							onChange={event => this.onChangeSearchInput(event, searchProps)}
							placeholder="Search"
							type="text"
							id="search-bar-1"
							aria-labelledby="search-bar-1-label"
						/>
					</label>
					{searchText && (
						<button onClick={this.clearSearch} className="btn btn-default clear-search">
							{'Clear'}
						</button>
					)}
					<YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={searchYear} grouping={this.state.grouping} updateYear={handleUpdateYear} addLoopCheck={true} />
				</div>
			);
		});

		return (
			<div ref={el => (this.componentRef = el)}>
				<div className="container-fluid">
					<fieldset>
					<legend className="lblRadioGroup">Template</legend>
					    <input
						    type="radio"
						    id="activeTempConf"
						    name="tempConfRecStatus"
						    checked={this.state.selectedOption === 'active'}
						    onChange={this.handleRdActiveStatusChange}
						    value="active"
						    className="lblRadioGroup"
					    />
					    <label className="lblRadioGroup" htmlFor="activeTempConf">Active</label>
					    <input
						    type="radio"
						    id="archiveTempConf"
						    name="tempConfRecStatus"
						    value="archive"
						    checked={this.state.selectedOption === 'archive'}
						    onChange={this.handleRdActiveStatusChange}
						    className="lblRadioGroup"
					    />
						<label className="lblRadioGroup" htmlFor="archiveTempConf">Archived</label>
					</fieldset>
				</div>
				<PaginationProvider
					pagination={paginationFactory({
						custom: true,
						totalSize: total,
						page: pageNo,
						sizePerPage: pageSize,
						showTotal: true,
						withFirstAndLast: true,
						alwaysShowAllBtns: true
					})}
					key={this.state.key}
					keyField={keyField}
					columns={columns}
					data={viewData}
				>
					{({ paginationProps, paginationTableProps }) => (
						<ToolkitProvider
							keyField={keyField}
							columns={columns}
							data={viewData}
							search={{ placeholder: 'Search...' }}
							exportCSV={{
								fileName: `contract_Management_${appointeeType}.csv`
							}}
						>
							{toolkitProps => {
								return (
									<div className="container-fluid">
										{showPagination && <div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
												flexWrap: 'wrap'
											}}
										>
											<div>
												<CustomSearch ref={el => (this.searchComponentRef = el)} {...toolkitProps.searchProps} />
											</div>

											{!this.areRowsHidden() && <PaginationListStandalone {...paginationProps} />}
											<div
												style={{
													position: 'relative',
													width: '275px',
													right: '75px'
												}}
											>
												{!this.areRowsHidden() && <SizePerPageDropdownStandalone {...paginationProps} />}
												<PaginationTotalStandalone dataSize={total} {...paginationProps} />
											</div>
										</div>
										}

										<BootstrapTable
											classes={'table table-primary table-striped table-sm table-responsive-md'}
											{...toolkitProps.baseProps}
											{...paginationTableProps}
											remote={{
												pagination: true,
												search: true
											}}
											onTableChange={this.handleTableChange}
											filter={filterFactory()}
											bootstrap4
											striped
											condensed
											hover
											size="sm"
											hiddenRows={hiddenRows}
											cellEdit={cellEditFactory({
												mode: 'click',
												blurToSave: true,
												autoSelectText: true,
												timeToCloseMessage: 10000,
												onStartEdit: this.onStartEdit,
												beforeSaveCell: (oldValue, newValue, row, column, done) => this.checkEditability(oldValue, newValue, row, column, done),
												afterSaveCell: (dunno, cell, rowData, colDef) => this.checkUpdate(colDef.dataField, cell, rowData)
											})}
										/>
										{!isLoaded && <Spinner />}

										{showPagination && (
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
													flexWrap: 'wrap'
												}}
											>
												<CustomCsvButton {...toolkitProps.csvProps} />
												<PaginationListStandalone {...paginationProps} />
												<div
													style={{
														position: 'relative',
														width: '275px',
														right: '75px'
													}}
												>
													<SizePerPageDropdownStandalone {...paginationProps} />
													<PaginationTotalStandalone dataSize={total} {...paginationProps} />
												</div>
											</div>
										)}
									</div>
								);
							}}
						</ToolkitProvider>
					)}
				</PaginationProvider>

				<AmendmentInfo count={amendments} />
				<div className="SelectButtonCell">
					{this.areRowsHidden() ? (
						<UnhideButton onClick={this.unhideRows} numberOfUpdates={amendments} />
					) : (hasAmendments &&
						<>
							<button
								style={{ height: '45px', width: '150px' }}
								onClick={this.previewClick}
								className={`react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm`}
							>
								{inPreview ? 'Remove Preview' : 'Show Preview'}
							</button>

							<button
								style={{ height: '45px', width: '150px' }}
								onClick={this.removeAllEdits}
								className={`react-bs-table-csv-btn btn btn-default btn btn-secondary btn-sm`}
							>
								Remove All Edits
							</button>
						</>
					)}
				</div>
			</div>
		);
	}
}

export default ContractTemplateDatatable;
